import key from 'weak-key';

// styles
import styles from './technical-drawings.module.scss';

// types
import type { SimpleListItem } from '../product.types';

// components
import { Image } from 'components/image/image';

// utils
import { useXy } from 'utils/hooks/use-xy';
import {
  imageAltSubcategory,
  imageAlt,
  getImageAltSuffix,
  imageAltDrawings,
} from '../ProductImageAlt';

type ProductDetailTechnicalDrawingsViewProps = {
  headline: string;
  drawings: any[];
  translationProductDrawingsPrefix?: string | null;
  categories: Omit<SimpleListItem, 'sequence'>[];
  productName: string;
  imageAltPrefix?: string | null;
  imageAltSuffix?: string | null;
  isProductImage?: boolean;
}

function ProductDetailTechnicalDrawingsView({
  drawings,
  categories,
  productName,
  headline = 'Product Drawings',
  imageAltPrefix = null,
  imageAltSuffix = null,
  translationProductDrawingsPrefix = null,
  isProductImage = false,
}: Readonly<ProductDetailTechnicalDrawingsViewProps>) {
  const imageAltCategory = imageAltSubcategory(categories);
  const imagePrefix = imageAlt(imageAltPrefix);
  const imageSuffix = getImageAltSuffix(imageAltSuffix);
  const isXy = useXy();

  const TitleTag = isXy ? 'h4' : 'h5';

  const imageAltText = isProductImage
    ? `${imagePrefix}${productName} - ${imageAltCategory}${imageSuffix}`
    : `${imagePrefix}${productName} ${imageAltDrawings(headline, categories, imageAltSuffix)}`;

  return (
    <div className={styles.technicalDrawings}>
      <TitleTag className={styles.technicalDrawingsHeadline}>
        {translationProductDrawingsPrefix
          ? `${translationProductDrawingsPrefix} ${headline}`
          : headline}
      </TitleTag>

      <div className="grid-x grid-margin-x">
        {drawings.map((drawing) => (
          <div key={key(drawing)} className="cell small-6 medium-4 large-2">
            <div className={styles.technicalDrawingsImgs}>
              <Image
                src={drawing.medium}
                alt={imageAltText}
                title={imageAltText}
                staticImage
                external
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductDetailTechnicalDrawingsView;
